export const cn = (...args: Array<string | boolean | undefined | null>) =>
  args.filter(Boolean).join(" ");

export const numberToMoney = (value?: number) => {
    return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
    }).format(value ?? 0);
};

export const emailValidationRegex =
    /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


export const isProduction = import.meta.env.VITE_ENVIROMENT === 'production';

export const createGalaxPay = (publicToken: string, production: boolean) =>
  new GalaxPay(publicToken, production);

export const formatDateToCelCoin = (date: string) => {
    const [month, year] = date.split("/");
    if (month && year) {
        const fullYear = 2000 + parseInt(year);
        return `${fullYear}-${month}`;
    } else {
        return date;
    }
}